import { createStore, compose, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'

import combinedReducer from './reducers/combinedReducer'

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

export default createStore(combinedReducer, composeEnhancer(applyMiddleware(thunk)))